module.exports = __webpack_public_path__ + "static/media/resume.9fad8c8f.pdf";